module.exports = __webpack_public_path__ + "img/return2.e795aba2.png";